import React, { useState } from "react";
import { Box, Typography, } from "@mui/material";
import { neutral400, primary500 } from "../../lib/rebrandColors/colors";
import BuildingCard from "../buildingCard";
import { useLocation, useOutletContext } from "react-router-dom";
import CustomIcon from "../icon";
import { black } from "../../lib/rebrandColors/colors";
import BuildingDetailsScreen from "../buildingDetails";
import BuildingForm from "../forms/addBuildingForm";

const BuildingsContainer = ({
  layoutProps,
}) => {
  // console.log('[buildings container] layout', layoutProps.buildings);
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal visibility state
  const [selectedBuilding, setSelectedBuilding] = useState({});
  const [isBuildingFormOpen, setIsBuildingFormOpen] = useState(false);
  const openBuildingForm = () => {
    setIsBuildingFormOpen(true);
  };
  const closeBuildingForm = () => {
    setIsBuildingFormOpen(false);
  };
  const buildingClick = (building) => {
    setIsModalOpen(true);
    setSelectedBuilding(building);
  };
  const buildingClickClose = (building) => {
    setIsModalOpen(false);
    setSelectedBuilding();
  };

  return (
    <Box sx={{
      width: "90%",
      height: "fit-content",
      borderRadius: "24px",
      backgroundColor: "#F9F9F9",
      display: "flex",
      flexDirection: "column",
      alignSelf: 'center'
    }}>
      {location.pathname === '/' &&
        <div style={{ marginLeft: '15px', marginTop: '39px', }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
          }}>
            <CustomIcon
              name="building"
              color={black}
              size={30}
            />
            <div
              className="bodyLarge"
              style={{
                marginLeft: '8px',
              }}
            >
              Buildings
            </div>
          </div>
        </div>
      }
      <Box sx={{
        display: "flex",
        justifyContent: "center",
        paddingBottom: '10px',
        marginTop: location.pathname !== '/' ? '10px' : '20px',
        // scale: location.pathname !== '/' ? 1.35 : 1,
        overflowX: 'scroll'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          gap: '5px',
          justifyContent: 'space-evenly',
        }}>
          {layoutProps.buildings.map((building) => (
            <div
              key={`${building.id}${building.name}`}
              style={{ minWidth: location.pathname !== '/' ? '250px' : '160px' }}
            >
              <BuildingCard
                key={`${building.id}${building.name}`}
                building={building}
                layoutProps={layoutProps}
                onDetailsClick={() => buildingClick(building)}
              />
            </div>
          ))}
          {/* Add Building Card, NOT ON DASHBOARD */}
          {location.pathname !== '/' &&
            <Box
              sx={{
                width: location.pathname !== '/' ? '250px' : "160px",
                height: location.pathname !== '/' ? '350px' : "260px",
                minWidth: '250px',
                borderRadius: "16px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#F0F0F0",
                cursor: 'pointer',
                gap: '5px',
              }}
              onClick={openBuildingForm}
            >
              <Typography sx={{
                fontSize: "24px",
                fontWeight: "600",
                color: primary500,
              }}>
                +
              </Typography>
              <Typography sx={{
                fontSize: "12px",
                fontWeight: "400",
                color: neutral400,
                textAlign: "center",
                marginTop: "8px",
              }}>
                Add building
              </Typography>
            </Box>
          }
        </div>
      </Box>
      {/* buildings modal */}
      {isModalOpen &&
        <BuildingDetailsScreen
          building={selectedBuilding}
          layoutProps={layoutProps}
          setSelectedBuilding={setSelectedBuilding}
          open={isModalOpen}
          handleClose={buildingClickClose}
        />
      }
      <BuildingForm
        open={isBuildingFormOpen}
        handleClose={closeBuildingForm}
        layoutProps={layoutProps}
      />
    </Box>
  );
};

export default BuildingsContainer;
